import styled from 'styled-components';

export const PriceHistoryWrapper = styled.div``;

export const PriceHistoryImg = styled.svg`
	width: 40px;
	height: 32px;
	fill: none;
	cursor: pointer;
	outline: none;
`;

export const PriceDiffTooltipWrapper = styled.div`
	width: 394px;
	display: flex;
	flex-direction: column;

	@media (max-width: 600px) {
		width: 98vw;
	}
`;

export const CommonWrapper = styled.div`
	padding: 16px 24px;
	&:not(:last-child) {
		border-bottom: ${({ theme }) => `1px solid ${theme.darkGrayColor}`};
	}
`;

export const PriceDiffTitle = styled(CommonWrapper)`
	${({ theme }) => theme.typography.textBoldM};
	color: ${({ theme }) => theme.primaryBlackColor};
`;

export const PriceDiffContent = styled(CommonWrapper)`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

export const PriceDiffScroll = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	overflow-y: scroll;
	max-height: calc((100vh - 56px) / 2);

	&::-webkit-scrollbar {
		-webkit-appearance: none;
		width: 4px;
	}

	&::-webkit-scrollbar-thumb {
		border-radius: 2px;
		background-color: ${({ theme }) => theme.darkGrayColor};
		-webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
	}

	@media (max-width: 1024px) {
		max-height: calc((100vh - 56px) / 2.5);
	}
`;

export const PriceDiffInfo = styled(CommonWrapper)`
	display: flex;
	flex-direction: column;
	gap: 16px;
`;

export const PriceAvgRow = styled.div`
	display: grid;
	grid-template-columns: 1.7fr 0.3fr;
	grid-gap: 20px;
`;

export const PriceDiffRow = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-gap: 22px;

	@media (max-width: 350px) {
		grid-gap: 14px;
	}
`;

export const PriceDate = styled.span`
	margin: 0;
	${({ theme }) => theme.typography.textMediumS};
	color: ${({ theme }) => theme.primaryBlackColor};
`;

export const PriceValue = styled.span`
	margin: 0;
	${({ theme }) => theme.typography.textSemiBoldS};
	color: ${({ theme }) => theme.primaryBlackColor};
`;

export const PriceDifference = styled.span`
	margin: 0;
	${({ theme }) => theme.typography.textMediumS};
	color: ${({ $isRise, theme }) => ($isRise ? theme.orangeColor : theme.topPlaceColor)};
`;

export const PriceMeterText = styled.span`
	margin: 0;
	${({ theme }) => theme.typography.textMediumS};
	color: ${({ theme }) => theme.primaryBlackColor};
`;

export const PricePerMeter = styled.span`
	margin: 0;
	${({ theme }) => theme.typography.textMediumS};
	color: ${({ theme }) => theme.darkGrayColor};
	white-space: nowrap;
`;

export const ShowMoreBtn = styled.button`
	border: none;
	box-shadow: none;
	background: transparent;
	${({ theme }) => theme.typography.textMediumS};
	color: ${({ theme }) => theme.primaryColor};
	text-decoration: underline;
	cursor: pointer;
	width: fit-content;
	padding: 0;

	&:hover {
		text-decoration: none;
	}
`;
